// The day's map on the Dispatch board and Schedule's Map (BL-018, maps package 5): with the session's
// maps key, ui-web's GoogleMap, in the page's light or dark, with the same pins, routes and shop DayMap
// draws (googleMapData) and the same pick. With the company's maps off (QA-756), GoogleMap's stand-in,
// which says so, with "Turn on in Settings" for someone who may, as the job page's map does. With no key
// on the server, or no reason given, DayMap exactly as before. Picking a pin does what it does on
// DayMap: the screen's onPick.
import type { DayMapProps, MapsLoader, MapTheme } from '@flowology/ui-web';
import { DayMap, GoogleMap } from '@flowology/ui-web/fl';
import { useShownTheme } from '../blueprint/theme.ts';
import { MAPS_TURN_ON } from '../shared/maps-turn-on.ts';
import { mapsLoader, useMaps, type MapsState } from '../shared/maps-key.ts';
import { googleMapData } from './pages-model.ts';

interface DayMapOrGoogleProps {
  data: DayMapProps;
  /** What the map is, for a screen reader, on Google's map: "Today’s visits on the map". */
  label: string;
  selected?: string | null;
  onPick?: (id: string) => void;
  /** With no pin to draw, DayMap's sentence in place of a map, whatever the maps (Schedule's Map). */
  none?: string;
}

/** Which map, from the session's maps: GoogleMap with a key or maps off, DayMap otherwise. */
export function dayMapOrGoogle(
  p: DayMapOrGoogleProps & { maps: MapsState; theme: MapTheme; loader?: MapsLoader | null },
) {
  const pick = {
    ...(p.selected === undefined ? {} : { selected: p.selected }),
    ...(p.onPick ? { onPick: p.onPick } : {}),
  };
  if (p.none !== undefined && !p.data.pins.length) return <DayMap data={p.data} none={p.none} />;
  const key = p.maps.key?.trim() || null;
  const off = !key && p.maps.off === 'company';
  if (!key && !off) return <DayMap data={p.data} {...pick} />;
  return (
    <GoogleMap
      data={googleMapData(p.data)}
      label={p.label}
      theme={p.theme}
      mapsKey={key}
      mapsOff={off ? 'company' : null}
      turnOn={off && p.maps.mayTurnOn ? MAPS_TURN_ON : null}
      {...pick}
      {...(p.loader === undefined ? {} : { loader: p.loader })}
    />
  );
}

export function DayMapOrGoogle(p: DayMapOrGoogleProps) {
  const maps = useMaps();
  const theme = useShownTheme();
  return dayMapOrGoogle({ ...p, maps, theme, loader: mapsLoader() });
}
